import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

import type { Variant } from './radioOption.type';

const VARIANT_STYLE = {
  default: {
    root: {
      padding: '0.75rem 1rem',
      border: 'none',
    },
  },
  card: {
    root: {
      padding: '1rem',
      border: `1px solid ${neutral['20']}`,
    },
  },
} as const;

export default makeStyles({
  root: ({ variant, fullWidth }: Props) => ({
    width: fullWidth ? '100%' : 'auto',
    margin: 0,
    padding: VARIANT_STYLE[variant].root.padding,
    gap: '0.75rem',
    color: neutral['100'],
    borderRadius: '1rem',
    border: VARIANT_STYLE[variant].root.border,
    '&.MuiFormControlLabel-labelPlacementStart': {
      justifyContent: 'space-between',
    },
  }),
  radio: {
    padding: 0,
    color: neutral['100'],
  },
  radioChecked: {
    color: neutral['100'],
  },
  labelRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    '& *': {
      fontFamily: 'PP Object Sans',
    },
  },
  labelTitle: {
    fontSize: '0.875rem',
    lineHeight: '1rem',
    fontWeight: 500,
  },
  labelDescription: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    color: neutral['60'],
  },
});

interface Props {
  variant: Variant;
  fullWidth: boolean;
}
